import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors, typography } from '../../styles/theme';
import { getCadParcelListCardCopy } from '../utils/cadParcelDisplay';

/**
 * Cabecera de card CAD en listados (manage / visitante): name primero,
 * title comercial en la misma línea si hay (altura uniforme entre cards).
 */
export default function CadParcelListHeading({ feature, headingSx = undefined }) {
  const { primary, subtitle } = getCadParcelListCardCopy(feature);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'baseline',
        gap: 0.75,
        minWidth: 0,
      }}
    >
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 600,
          color: colors.textPanelTitle,
          fontFamily: typography.fontFamily.primary,
          lineHeight: '18px',
          whiteSpace: 'nowrap',
          flexShrink: 0,
          ...headingSx,
        }}
      >
        {primary}
      </Typography>
      {subtitle ? (
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: typography.fontWeight.regular,
            color: colors.textSecondary,
            fontFamily: typography.fontFamily.primary,
            lineHeight: '16px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            minWidth: 0,
            flex: 1,
          }}
        >
          {subtitle}
        </Typography>
      ) : null}
    </Box>
  );
}
